import useTranslations from '../../../hooks/useTranslations'
import { entries } from '../../../utils/javascript'

const LaborSocialStandard = () => {
  const { t } = useTranslations()
  const data = {
    inv_KeyLaborLegislation: [
      'inv_LaborLegislation1',
      'inv_LaborLegislation2',
      'inv_LaborLegislation3',
      'inv_LaborLegislation4',
      'inv_LaborLegislation4',
    ],
    inv_LaborCodes: [
      'inv_LaborCodes1',
      'inv_LaborCodes1',
      'inv_LaborCodes1',
      'inv_LaborCodes1',
    ],
  }

  return (
    <>
      {entries(data).map(([title, dataArr], ind) => (
        <div key={ind} className="mb-20">
          <h3>{t(title)}</h3>
          <ul className="pl-15 ml-15 mt-10">
            {dataArr.map((str, i) => (
              <li key={i} className="fs-15">
                {t(str)}
              </li>
            ))}
          </ul>
        </div>
      ))}
    </>
  )
}

export default LaborSocialStandard
